module.exports = __webpack_public_path__ + "img/Menu-Get_13.6005061e.png";